module.exports = __webpack_public_path__ + "img/melia-pool.49e6a4b3.jpg";